export default __webpack_public_path__ + "static/media/social-facebook.49ce997e.svg";